<script>
  export let title;
  export let preview_text;
</script>

<div class="card">
  <div class="card__title text-bold">{title}</div>
  <div class="card__preview-text">{preview_text}</div>
</div>

<style lang="scss">
  .card {
    border: 2px solid rgba(240, 240, 240, 1);
    padding: 20px;
    border-radius: 10px;
    color: rgba(90, 95, 109, 1);
    box-shadow: 0px 2px 8px 0px rgba(16, 16, 122, 0.16);
    margin-bottom: 24px;

    @media (min-width: 320px) and (max-width: 1000px) {
      margin: 24px 0;
    }
  }

  .card__title {
    font-size: 26px;
    line-height: 34px;
  }

  .card__preview-text {
    font-size: 16px;
    line-height: 23px;
    margin-top: 12px;
  }
</style>